// Modal.js
import React from 'react';
import './alertModal.css';
import { useTranslation } from 'react-i18next';


const Modal = ({ show, handleClose, message }) => {
  const {t} = useTranslation();
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay-report">
      <div className="modal-content-report">
        <p className='modalText-report'>{message}</p>
        <button className= 'reportModalBtn' onClick={handleClose}>{t("reports_dateBtn")}</button>
      </div>
    </div>
  );
};

export default Modal;
